export enum ImageEngineEnum {
  GPT_IMAGE_2 = 1,
  RECRAFT_V3 = 2,
  GEMINI_2_5_FLASH_IMAGE = 3,
}
